import { SvgIcon, SvgIconProps } from '@mui/material';

const ArrowDownSvgIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7071 17.293C16.3166 16.9025 15.6834 16.9025 15.2929 17.293C14.9024 17.6835 14.9024 18.3167 15.2929 18.7072L19.4929 22.9072C19.5417 22.956 19.5943 22.9988 19.6498 23.0354C20.0379 23.2917 20.5654 23.2489 20.9071 22.9072L25.1071 18.7072C25.4976 18.3167 25.4976 17.6835 25.1071 17.293C24.7166 16.9025 24.0834 16.9025 23.6929 17.293L20.2 20.7859L16.7071 17.293Z"
        fill="#606060"
      />
    </SvgIcon>
  );
};

export default ArrowDownSvgIcon;
